import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderNothing } from 'recompose';
import _ from 'lodash';


import JobApprovalPanel from '../components/JobApprovalPanel';
import TicketApprovalReview from './TicketApprovalReview';


import jobApprovalReview from '../graphql/jobApprovalReview';
import { nodeType } from '../../../propTypes';
import { selectTicketId, approveJobId } from '../actions';
import { getCurrentJobId, getCurrentTicketId } from '../selectors';
import { getApiServerUrl } from '../../configuration/selectors';


const propTypes = exact({
  // eslint-disable-next-line react/no-unused-prop-types
  jobId: PropTypes.number.isRequired,
  ticketId: PropTypes.number.isRequired,
  tickets: PropTypes.arrayOf(nodeType).isRequired,
  job: nodeType.isRequired,
  selectTicketIdAction: PropTypes.func.isRequired,
  approveJobIdAction: PropTypes.func.isRequired,
  apiServerUrl: PropTypes.string.isRequired,
});


const JobApprovalReview = (props) => {
  const {
    approveJobIdAction,
    selectTicketIdAction,
    tickets,
    ticketId,
    job,
    apiServerUrl,
  } = props;

  return (
    <JobApprovalPanel
      job={job}
      tickets={tickets}
      selectedTicketId={ticketId}
      selectTicketId={selectTicketIdAction}
      approveJobId={approveJobIdAction}
      apiServerUrl={apiServerUrl}
    >
      <TicketApprovalReview jobId={job.id} />
    </JobApprovalPanel>
  );
};


JobApprovalReview.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    jobId: getCurrentJobId(state),
    ticketId: getCurrentTicketId(state),
    apiServerUrl: getApiServerUrl(state),
  };
};


const mapDispatchToProps = {
  selectTicketIdAction: selectTicketId,
  approveJobIdAction: approveJobId,
};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withSelectFirstJob = lifecycle({
  componentWillMount() {
    const { tickets, selectTicketIdAction } = this.props;
    if (tickets.length > 0) {
      selectTicketIdAction(tickets[0].id);
    }
  },
  componentWillReceiveProps(nextProps) {
    const { tickets, selectTicketIdAction } = this.props;
    const { tickets: nextTickets } = nextProps;
    if (_.isEqual(tickets, nextTickets)) {
      return;
    }
    if (nextTickets.length > 0) {
      selectTicketIdAction(nextTickets[0].id);
    }
  },
});


const withHideNoTicket = branch(
  (props) => { return props.ticketId === null; },
  renderNothing,
);


const withHideNoJob = branch(
  (props) => { return props.jobId === null; },
  renderNothing,
);


const enhance = compose(
  withRedux,
  withHideNoJob,
  jobApprovalReview,
  withSelectFirstJob,
  withHideNoTicket,
);


export default enhance(JobApprovalReview);
